import { createAction, props } from '@ngrx/store';
import { IToast } from './model';

export const AddToast = '[Toast] Add Toast'
export const RemoveToast = '[Toast] Remove Toast'
export const SetShowToast = '[Toast] Set Show Toast'

export const addToast = createAction(
  AddToast,
  props<{ toast: IToast }>()
);
export const removeToast = createAction(
  RemoveToast,
  props<{ id: number }>()
);
export const setShowToast = createAction(
  SetShowToast,
  props<{ id: number, show: boolean }>()
);
